import React from 'react';


class Databasekanjaban extends React.Component{
    render(){
        return (
            <React.Fragment>
              <div className="Page">
                 <div className="OneApp">
                        <h5>Kanjaban data base</h5>
                        
                        
                        <img src="https://raw.githubusercontent.com/BrandonGrimaldoM/KanjabanDataBase/master/BD/ERM.PNG" width="700" height="560" align="center" alt="kanja"/>
                        
                        
                        
                        
                        <p align="left">Esta base de datos en MySql pertenece a la aplicación kanjaban</p>
                        
                        <p align="left">Puedes ver el repositorio dando click <a href="https://github.com/BrandonGrimaldoM/KanjabanDataBase" target="_blank" rel='noreferrer'>AQUI.</a></p>
                        
                        <div className="space"></div>
                        
                        
                 </div>
                 
                
             </div>
          
            </React.Fragment>
        ); 
    }
}

export default Databasekanjaban;